import React, {useMemo, useState} from 'react';

import {useStore} from 'effector-react';

import {useTranslation} from 'react-i18next';

import {useInvoiceLinesColumns} from 'components/pages/DocumentsCreate/InvoiceNew/hooks/useInvoiceLinesColumns';
import {useLineCalculations} from 'components/pages/DocumentsCreate/InvoiceNew/hooks/useLineCalculations';
import {Modal} from 'components/ui-kit/Modal';
import {mapTableColumns} from 'components/ui-kit/Table2.0/columns-mapper';
import {$invoiceLinesHolder, updateInvoiceLinesHolder} from 'models/documents/invoices/create';
import {getRowAtPath} from 'models/documents/invoices/create/init';
import {
    $modalTransportCodesModal,
    setModalTransportCodesModal,
} from 'models/documents/invoices/details';

import {PackageTypes, TRANSPORT_PACKAGE_TYPES} from 'types/gtins';
import {InvocieLineHolder, InvoiceLine} from 'types/invoices';

import {PaginationControlsProps, SimpleTable, SimpleTablePagination} from '../SimpleTable';

export const ModalTransportCodes = () => {
    const {t: translation} = useTranslation();
    const GEN_INFO = 'pages.documents.invoices.create.grouping';
    const t = (key: string) => translation(`${GEN_INFO}.${key}`);
    const modalTransportCodesModal = useStore($modalTransportCodesModal);
    const invoiceLinesHolder = useStore($invoiceLinesHolder);
    const [paginationProps, setPaginationProps] = useState<PaginationControlsProps | null>(null);

    const row = getRowAtPath(invoiceLinesHolder, modalTransportCodesModal.id);

    function onCloseModal() {
        setModalTransportCodesModal({show: false, id: ''});
    }

    const {columnsSettings} = useInvoiceLinesColumns();
    const columns = useMemo(() => mapTableColumns(columnsSettings), [columnsSettings]);

    const data = useMemo(() => row?.subRows ?? [], [row]);

    const {combineValues, calculateLineAmountWVat} = useLineCalculations();
    const updateMyData = (
        columnId: string,
        value: string | object | null,
        depth: {step: number; id: string},
    ) => {
        const {step, id} = depth;
        updateInvoiceLinesHolder({
            data: {columnId, value: value as any},
            depth: {step, id},
        });
        if (columnId === 'price' || columnId === 'qty') {
            combineValues(id);
            calculateLineAmountWVat(id);
        }
        if (columnId === 'vatCategory' || columnId === 'vat') {
            calculateLineAmountWVat(id, columnId);
        }
    };

    return (
        <Modal
            show={modalTransportCodesModal.show}
            onClose={onCloseModal}
            title={`${row?.packagingType} ${row?.code}`}
            footer={
                <div>
                    {paginationProps && data.length > 0 && (
                        <div>
                            <SimpleTablePagination {...paginationProps} />
                        </div>
                    )}
                </div>
            }
            modalWidth={3}
        >
            <div style={{height: '100vh', maxHeight: '675px', overflowY: 'auto'}}>
                <SimpleTable
                    columns={columns}
                    data={data}
                    updateMyData={updateMyData}
                    onPaginationReady={setPaginationProps}
                    initialState={{pageIndex: 0, pageSize: 8}}
                    skipPageReset={true}
                    renderExpandedRow={true}
                    modalParentComponent={{row, parentIndex: modalTransportCodesModal.id}}
                    getRowCanExpand={(row) => {
                        const {packagingType} = row.original as InvocieLineHolder;
                        // return packagingType === PackageTypes.BOX;
                        if (!packagingType) return false;
                        return TRANSPORT_PACKAGE_TYPES.includes(packagingType);
                    }}
                    // showExpandableColumn={false}
                    expandableColumnId="lineId"
                    tableViewExtraSettings={{
                        tdThPadding: '5px 10px',
                        overflowX: 'visible',
                    }}
                    cellContainerSettings="width: 100%; height: 60px; align-items: flex-end;"
                />
            </div>
        </Modal>
    );
};
